import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class FxAzService {

    constructor(protected generalService: GeneralService) {
    }

    public async calcFaixaAzulTemperatura(pTempMaxTrajeto: number, pTempMaxTransporte: number): Promise<string> {
        if (pTempMaxTrajeto >= 40 || pTempMaxTransporte >= 40) {
            return 'SIM';
        }
        return 'NÃO';
    }

    public async calcFaixaAzulPorTempoMonitorado(pTempoEsperaPatio: number, pTempoTotalTransporte: number, pTipoColheita: string, pLinhaDescarga: string): Promise<string> {
        console.log(pLinhaDescarga)
        if(pLinhaDescarga === 'MANUAL'){
            if (pTempoTotalTransporte > 14) {
                return 'SIM';
            }
            return 'NÃO';
        }
        if(pTipoColheita === 'GRANEL'){
            if (pTempoTotalTransporte > 14) {
                return 'SIM';
            }
            return 'NÃO';
        }
        if (pTempoEsperaPatio > 12) {
            return 'SIM';
        }
        return 'NÃO';
    }

    // public async calcFaixaAzulTemperatura(pTempMaxTrajeto: number, pTempMaxTransporte: number): Promise<string> {
    //     if (!!pTempMaxTrajeto || !!pTempMaxTransporte){
    //         if (pTempMaxTrajeto >= 40 || pTempMaxTransporte >= 40) {
    //             return 'SIM';
    //         }
    //         return 'NÃO';
    //     }

    //     return 'N/A'
    // }

    // public async calcFaixaAzulPorTempoMonitorado(pTempoEsperaPatio: number, pTempoTotalTransporte: number, pTempMaxTrajeto: number, pTempMaxTransporte: number): Promise<string> {
    //     if (!!pTempMaxTrajeto || !!pTempMaxTransporte){
    //         return 'N/A'
    //     }
    //     if (pTempoEsperaPatio >= 16 || pTempoTotalTransporte >= 16) {
    //         return 'SIM';
    //     }
    //     return 'NÃO';
    // }

    public async calcFaixaAzulPorTransbordo(pCargaTransbordo: string, pTempoTransbordo: number): Promise<string> {
        //pTempoTransbordo = pTempoTransbordo.replace(',', '.');
        if (Number(pTempoTransbordo) >= 12 && pCargaTransbordo === 'SIM') {
            //console.log('calcFaixaAzulPorTransbordo');
            return 'SIM';
        }
        //console.log('ElsecalcFaixaAzulPorTransbordo');
        return 'NÃO';
    }

    public async calcFaixaAzulGeral(pFxAzulCampo: string, pFxAzulUmidade: string, pFxAzulTemperatura: string, pFxAzulTempo: string, pFxAzulTransbordo: string): Promise<string> {
        let fxAzulCampo: string = 'NÃO';
        pFxAzulUmidade = !!pFxAzulUmidade ? pFxAzulUmidade : 'NÃO';
        pFxAzulTemperatura = !!pFxAzulTemperatura ? pFxAzulTemperatura : 'NÃO';
        pFxAzulTempo = !!pFxAzulTempo ? pFxAzulTempo : 'NÃO';
        pFxAzulTransbordo = !!pFxAzulTransbordo ? pFxAzulTransbordo : 'NÃO';

        if (!!pFxAzulCampo && (pFxAzulCampo.includes('FISIOLÓGICO SCORE') || pFxAzulCampo.includes('MORTE PREMATURA') || pFxAzulCampo.includes('LIBERAÇÃO ESPECIAL'))) {
            fxAzulCampo = 'SIM';
        }

        if (fxAzulCampo.includes('SIM') ||
            pFxAzulUmidade.includes('SIM') ||
            pFxAzulTemperatura.includes('SIM') ||
            pFxAzulTempo.includes('SIM') ||
            pFxAzulTransbordo.includes('SIM')) {
            return 'SIM';
        }

        return 'NÃO';
    }
}
